import { Icon, Tooltip } from ".."
import { DATE_FORMAT, TIME_FORMAT } from "../../../constants"
import { dateTimeFunction } from "../../../utils/date"

const DateFormat = ({
  dateClassName = "gray-800",
  date: d,
  showTime,
  dateFormat = DATE_FORMAT,
  color = "red",
  icon = "BiCalendar",
  customTooltip,
  showTimeWithTooltip = true,
  dateColor,
  iconColor = "",
  iconSize = "14px",
}) => {
  let date = dateTimeFunction({ date: d, format: dateFormat })
  let time = dateTimeFunction({ date: d, format: TIME_FORMAT })

  const renderTooltip = () =>
    typeof customTooltip === 'function'
      ? customTooltip()
      : `${customTooltip ? customTooltip : ""} ${date}${showTimeWithTooltip ? `, ${time}` : ""}`

  return (
    d && (
      <div className={dateClassName} style={{ cursor: !!showTime ? "default" : "pointer" }}>
        <Tooltip title={renderTooltip()}>
          {icon && <Icon color={iconColor} icon={icon} size={iconSize} />}
          &nbsp; {dateColor ? <span style={{ color: dateColor }}>{date}</span> : date}
          {showTime && <span style={{ color: color }}>&nbsp; {time}</span>}
        </Tooltip>
      </div>
    )
  )
}

export default DateFormat
